module.exports = __webpack_public_path__ + "static/media/backgrounder-leatherworking-tool.b12b11fd.webp";